import React, { Component } from 'react'
import { Modal, Button } from 'react-bootstrap'

class CaratulaSaveStatus extends Component {
  render () {
    const {
      onSubmit,
      codigo,
      mensaje,
      id,
      status
    } = this.props

    return (
      <div >
        <Modal show={status} style={{ display: 'flex', flexWrap: 'wrap' }} centered autoFocus onHide={() => null}>
          <Modal.Header>
            <h3>Atención</h3>
          </Modal.Header>
          <Modal.Body>
            <h4>{mensaje}</h4>
            <h5>{id}</h5>
            <h5>Código: {codigo}</h5>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => onSubmit()} variant='primary'>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  };
};

export default CaratulaSaveStatus
